import { Action } from '@ngrx/store';

import { MhSelectionState } from './selection-state.entity';
import { SelectionActions, SelectionActionTypes } from './selection.actions';

export const emptySelectionState: MhSelectionState = { selection: undefined, failed: false };

export function selectionReducer(state = emptySelectionState, action: Action): MhSelectionState {
    const specificAction: SelectionActions = action as SelectionActions;
    switch (specificAction.type) {
        case SelectionActionTypes.Set:
            return { ...state, selection: specificAction.payload, failed: false };

        case SelectionActionTypes.Unset:
            return emptySelectionState;
        case SelectionActionTypes.Fail:
            return { ...emptySelectionState, failed: true };
        default:
            return state;
    }
}
